module.exports = __webpack_public_path__ + "media/img/pages/companies/tcs-615370c69fc31f3634ccc3c5e5a6d80a.png";